export const VENDOR_ROUTES = {
  list: '/staff/vendors',
  new: '/staff/vendors/new',
  edit: '/staff/vendors/:id/edit',
} as const;
